<template>
    <div class="app-container main">
        <div class="remark-container">
            <el-row class="remark-title"><span>项目备注</span><el-button type="text" @click="showPhaseRemarkForm(true)" style="margin-left:15px">修改</el-button></el-row>
            <el-row class="remark-content">{{ phaseRemark }}</el-row>
        </div>
        <el-dialog title="修改项目备注" :visible.sync="phaseRemarkFormVisiable" :close-on-click-modal="false" :close-on-press-escape="true" width="30%">
            <el-form :model="phaseRemarkModel" :rules="phaseRemarkRules" ref="phaseRemarkForm" label-width="120px">
                <el-form-item label="备注:" prop="phaseRemark">
                    <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" :maxlength="200" show-word-limit v-model="phaseRemarkModel.phaseRemark" placeholder="请输入200字以内" clearable/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showPhaseRemarkForm(false)">取消</el-button>
                <el-button type="primary" @click="reqUpdatePhaseRemark">确认</el-button>
            </span>
        </el-dialog>

        <div class="container">
            <div>
                <template>
                    <div class="phaseTitle">
                        <span>项目阶段</span>
                        <el-button type="primary" class="btn" @click="showPhaseForm(true, null)">新增项目阶段</el-button>
                    </div>
                    <div :class="['phaseCard', { active: currentPhase && currentPhase.id === phase.id }]" v-for="phase in phaseList" :key="phase.phaseNo" @click="changeCurrentPhase(phase)">
                        <div>阶段{{ phase.phaseNo }}
                            <span class="phaseCardType">
                                <span v-if="phase.phaseType === 1">技术</span>
                                <span v-else-if="phase.phaseType === 2">生产</span>
                                <span v-else-if="phase.phaseType === 3">采购</span>
                                <span v-else-if="phase.phaseType === 4">施工</span>
                                <span v-else-if="phase.phaseType === 5">调试</span>
                                <span v-else-if="phase.phaseType === 6">验收</span>
                                <span v-else-if="phase.phaseType === 7">售后</span>
                            </span>
                        </div>
                        <div>负责人: <span class="phaseCardResponsor">{{ phase.responsorName }}</span></div>
                        <div class="phaseCardThree">
                            <span>节点时间: &nbsp;{{ phase.nodeTime }}</span>
                            <span class="phaseCardActions">
                                <el-button type="text" @click.stop="showPhaseFollowDialog(phase)">进展</el-button>
                                <el-button type="text" @click.stop="showPhaseForm(true, phase)">编辑</el-button>
                                <el-button type="text" @click.stop="reqDeletePhase(phase.id)" style="color:red">删除</el-button>
                            </span>
                        </div>
                    </div>
                </template>
                <el-dialog :title="phaseFormTitle===1?'新增':'编辑'" :visible.sync="phaseFormVisible" :close-on-click-modal="false" :close-on-press-escape="true" width="40%">
                    <el-form :model="phaseModel" :rules="phaseRules" ref="phaseForm" label-width="120px">
                        <el-row :gutter="16">
                            <el-col :span="12">
                                <el-form-item label="项目阶段:" prop="phaseType">
                                    <el-select v-model="phaseModel.phaseType" clearable filterable placeholder="请选择项目阶段" style="width: 100%">
                                        <el-option v-for="item in phaseTypes" :key="item.key" :label="item.value" :value="item.key"/>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="阶段顺序:" prop="phaseNo">
                                    <el-input type="number" show-word-limit v-model="phaseModel.phaseNo" placeholder="填写整数，数字越大排序越后" clearable style="width: 100%"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="16">
                            <el-col :span="12">
                                <el-form-item label="阶段负责人:" prop="responsor">
                                    <UserSelect v-model="phaseModel.responsor" placeholder="请选择负责人" style="width: 100%"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="节点时间:" prop="nodeTime">
                                    <el-date-picker v-model="phaseModel.nodeTime" value-format="yyyy-MM-dd" type="date" placeholder="选择节点时间" style="width: 100%"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="showPhaseForm(false, null)">取消</el-button>
                        <el-button type="primary" @click="reqSavePhase">确认</el-button>
                    </span>
                </el-dialog>
                <el-dialog :title="'阶段进展' + (phaseFollowName ? ' - ' + phaseFollowName : '')" :visible.sync="phaseFollowVisible" :close-on-click-modal="false" :close-on-press-escape="true" width="65%" append-to-body>
                    <FollowAdd
                        v-if="phaseFollowPhase"
                        :key="'phase-follow-add-' + phaseFollowPhase.id"
                        ref="phaseFollowAdd"
                        :targetId="contractId"
                        targetType="contract"
                        :contractPhaseId="phaseFollowPhase.id"
                        :simpleMode="true"
                        @success="handlePhaseFollowSuccess"
                    />
                    <div v-if="phaseFollowPhase" v-show="phaseFollowListVisible" class="phase-follow-dialog-list">
                        <FollowList
                            :key="'phase-follow-list-' + phaseFollowPhase.id"
                            ref="phaseFollowList"
                            :targetId="contractId"
                            targetType="contract"
                            :contractPhaseId="phaseFollowPhase.id"
                            :hideEmptyTip="true"
                            :hideCurrentTargetInfo="true"
                            @list-change="handlePhaseFollowListChange"
                        />
                    </div>
                </el-dialog>
            </div>
            <div class="content">
                <div class="phaseTitle">
                    <span>施工内容</span>
                    <el-button v-if="this.currentPhase" type="primary" class="btn" @click="showConstructionForm(true, null, 1)">新增施工内容</el-button>
                </div>
                <el-table :data="constructionList">
                        <el-table-column label="施工内容" min-width="100" align="center" prop="content" width="160"></el-table-column>
                        <el-table-column label="计划开始日期" min-width="100" align="center" prop="planStart"></el-table-column>
                        <el-table-column label="计划结束日期" min-width="100" align="center" prop="planEnd"></el-table-column>
                        <el-table-column label="计划持续天数" min-width="100" align="center" prop="planDays"></el-table-column>
                        <el-table-column label="实际开始日期" min-width="100" align="center" prop="actualStart"></el-table-column>
                        <el-table-column label="实际结束日期" min-width="100" align="center" prop="actualEnd">
                            <template slot-scope="scope">
                                <span v-if="scope.row.progress === 2" style="color:red;">{{ scope.row.actualEnd }}</span>
                                <span v-else>{{ scope.row.actualEnd }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="实际持续天数" min-width="100" align="center" prop="actualDays">
                            <template slot-scope="scope">
                                <span v-if="scope.row.progress === 2" style="color:red;">{{ scope.row.actualDays }}</span>
                                <span v-else>{{ scope.row.actualDays }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" min-width="100" align="center" prop="remark" width="160" show-overflow-tooltip></el-table-column>
                        <el-table-column label="进度" min-width="100" width="120px" align="center" prop="progress" fixed="right">
                            <template slot-scope="scope">
                                <div v-if="scope.row.progress === 0" class="progress" style="background-color: #e1e600;">进行中</div>
                                <div v-if="scope.row.progress === 1" class="progress" style="background-color: #70b603;">正常</div>
                                <div v-if="scope.row.progress === 2" class="progress" style="background-color: #ec808d;">超期{{ scope.row.difference }}天</div>
                                <div v-if="scope.row.progress === 3" class="progress" style="background-color: #02a7f0;">提前{{ scope.row.difference }}天</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="220px" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="text" @click="showConstructionForm(true, scope.row, 1)">编辑项目</el-button>
                                <el-button type="text" @click="showConstructionForm(true, scope.row, 2)">编辑实际工期</el-button>
                                <el-button type="text" @click="reqDeleteConstruction(scope.row.id)" style="color:red">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination v-if="total" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="queryConstructionList"/>
                <el-dialog :title="constructionFormTitle===1 ? '新增':'编辑'" :visible.sync="constructionFormVisible" :close-on-click-modal="false" :close-on-press-escape="true" width="50%">
                    <el-form :model="constructionModel" :rules="constructionRules" ref="constructionForm" label-width="120px">
                        <el-row :gutter="16">
                            <el-col :span="12">
                                <el-form-item label="项目阶段:" prop="phaseType">
                                    <el-select v-model="constructionModel.phaseType" clearable filterable placeholder="请选择项目阶段" style="width: 100%" disabled>
                                        <el-option v-for="item in phaseTypes" :key="item.key" :label="item.value" :value="item.key"/>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="施工内容:" prop="content">
                                    <el-input v-model="constructionModel.content" placeholder="请输入施工内容" :disabled="editType === 2"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="16">
                            <el-col :span="12">
                                <el-form-item label="计划开始日期:" prop="planStart">
                                    <el-date-picker v-model="constructionModel.planStart" value-format="yyyy-MM-dd" type="date" placeholder="选择计划开始日期"
                                    :disabled="editType === 2" style="width: 100%" @change="validatePlanEnd"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="计划结束日期:" prop="planEnd">
                                    <el-date-picker v-model="constructionModel.planEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择计划结束日期"
                                    :disabled="editType === 2" style="width: 100%" @change="validatePlanStart"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="16" v-if="editType === 2">
                            <el-col :span="12">
                                <el-form-item label="实际开始日期:" prop="actualStart">
                                    <el-date-picker v-model="constructionModel.actualStart" value-format="yyyy-MM-dd" type="date" placeholder="选择实际开始日期"
                                    style="width: 100%" @change="validateActualEnd"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="实际结束日期:" prop="actualEnd">
                                    <el-date-picker v-model="constructionModel.actualEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择实际结束日期"
                                    style="width: 100%" @change="validateActualStart"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="16" v-if="editType === 1">
                            <el-col :span="24">
                                <el-form-item label="备注:" prop="remark">
                                    <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" :maxlength="200" show-word-limit v-model="constructionModel.remark" placeholder="请输入200字以内" clearable/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="showConstructionForm(false, null, 0)">取消</el-button>
                        <el-button type="primary" @click="reqSaveConstruction">确认</el-button>
                    </span>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        updatePhaseRemark,
        queryContractPhaseList,
        saveContractPhase,
        deleteContractPhase,
        queryConstructionList,
        saveConstruction,
        deleteConstruction
    } from "@/api/crm/contract";
    import UserSelect from "@/views/crm/components/userSelect";
    import FollowAdd from "@/views/crm/follow/followAdd";
    import FollowList from "@/views/crm/follow/followList";

    export default {
        name: "contractPhase",
        data() {
            return {
                phaseList: [], //项目阶段列表
                constructionList: [], //施工内容列表
                total: 0, //施工内容数量
                //施工内容分页参数
                queryParams: {
                    pageNum: 1,
                    pageSize: 20
                },
                currentPhase: null, //当前选择的项目阶段
                editType: null, //1编辑施工内容 2编辑实际工期


                phaseRemarkFormVisiable: false, //控制修改项目备注对话框是否显示
                phaseFormVisible: false, //控制新增/修改项目阶段对话框是否显示
                phaseFormTitle: 1,//1新增项目阶段 2编辑项目阶段
                constructionFormVisible: false, //控制新增/修改施工内容对话框是否显示
                constructionFormTitle: 1,//1新增施工内容 2编辑施工内容
                phaseFollowVisible: false,
                phaseFollowPhase: null,
                phaseFollowListVisible: false,


                //项目备注model
                phaseRemarkModel :{
                    id: this.contractId,
                    phaseRemark: this.phaseRemark
                },
                //项目备注验证规则
                phaseRemarkRules: {
                    phaseRemark: [
                        {required: true, message: '请填写项目备注', trigger: 'blur'}
                    ]
                },
                //项目阶段model
                phaseModel: {
                    id: null,
                    contractId: this.contractId,
                    phaseNo: null,
                    phaseType: null,
                    responsor: null,
                    nodeTime: null
                },
                //项目阶段验证规则
                phaseRules: {
                    phaseNo: [
                        {required: true, message: '请填写阶段顺序', trigger: 'change'},
                        {
                            validator: (rule, value, callback) => {
                            // 空值交给前面的 required 校验
                            if (value === undefined || value === null || value === '') {
                                callback()
                                return
                            }
                            // 1. 必须大于 0
                            if (value <= 0) {
                                callback(new Error('阶段顺序必须大于0'))
                                return
                            }
                            // 2. 小数位不能超过 2 位
                            const valueStr = value.toString()
                            if (valueStr.indexOf('.') !== -1) {
                                callback(new Error('阶段顺序必须是整数'))
                                return
                            }
                            // 校验通过
                            callback()
                            },
                            trigger: 'change'
                        }
                    ],
                    phaseType: [
                        {required: true, message: '请选择项目阶段', trigger: 'blur'}
                    ],
                    responsor: [
                        {required: true, message: '请选择阶段负责人', trigger: 'blur'}
                    ],
                    nodeTime: [
                        {required: true, message: '请选择节点时间', trigger: 'blur'}
                    ],
                },
                //施工内容model
                constructionModel: {
                    id: null,
                    phaseId: null,
                    phaseType: null,
                    content: null,
                    planStart: null,
                    planEnd: null,
                    actualStart: null,
                    actualEnd: null,
                    remark: ''
                },
                //施工内容验证规则
                constructionRules: {
                    content: [
                        {required: true, message: '施工内容不能为空', trigger: 'blur'}
                    ],
                    planStart: [
                        {required: true, message: '请选择计划开始日期', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                const end = this.constructionModel.planEnd
                                if (end && value && value > end) {
                                    callback(new Error('计划开始日期不能晚于结束日期'))
                                } else {
                                    callback()
                                }
                            },
                            trigger: 'change'
                        }
                    ],
                    planEnd: [
                        {required: true, message: '请选择计划结束日期', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                const start = this.constructionModel.planStart
                                if (start && value && value < start) {
                                    callback(new Error('计划结束日期不能早于开始日期'))
                                } else {
                                    callback()
                                }
                            },
                            trigger: 'change'
                        }
                    ],
                    actualStart: [
                        {required: true, message: '请选择实际开始日期', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                const end = this.constructionModel.actualEnd
                                if (end && value && value > end) {
                                    callback(new Error('实际开始日期不能晚于结束日期'))
                                } else {
                                    callback()
                                }
                            },
                            trigger: 'change'
                        }
                    ],
                    actualEnd: [
                        {required: true, message: '请选择实际结束日期', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                const start = this.constructionModel.actualStart
                                if (start && value && value < start) {
                                    callback(new Error('实际结束日期不能早于开始日期'))
                                } else {
                                    callback()
                                }
                            },
                            trigger: 'change'
                        }
                    ]
                },


                phaseTypes: [{
                        key: 1,
                        value: '技术'
                    },{
                        key: 2,
                        value: '生产'
                    },{
                        key: 3,
                        value: '采购'
                    },{
                        key: 4,
                        value: '施工'
                    },{
                        key: 5,
                        value: '调试'
                    },{
                        key: 6,
                        value: '验收'
                    },{
                        key: 7,
                        value: '售后'
                    }
                ]
            }
        },
        props: {
            contractId: {
                type: Number,
                require: true
            },
            phaseRemark: {
                type: String,
                require: true
            }
        },
        watch: {
            phaseRemark(newValue) {
                this.phaseRemarkModel.phaseRemark = newValue
            }
        },
        computed: {
            phaseFollowName() {
                if (!this.phaseFollowPhase) {
                    return ''
                }
                const phaseType = this.phaseTypes.find(item => item.key === this.phaseFollowPhase.phaseType)
                return `阶段${this.phaseFollowPhase.phaseNo}${phaseType ? ' · ' + phaseType.value : ''}`
            }
        },
        components: {
            UserSelect,
            FollowAdd,
            FollowList
        },
        created() {
            this.queryPhaseList()
        },
        methods: {
            // 查询项目阶段
            queryPhaseList () {
                queryContractPhaseList(this.contractId).then(response => {
                    const {code, msg, data} = response
                        if (code == 200) {
                            this.phaseList = data || [];
                            if(this.phaseList.length > 0) {
                                this.changeCurrentPhase(this.phaseList[0])
                                this.queryConstructionList()
                            } else {
                                this.changeCurrentPhase(null)
                            }
                        }
                })
            },
            queryConstructionList() {
                if(!this.currentPhase) {
                    this.constructionList = [];
                    this.total = 0
                } else {
                    queryConstructionList(Object.assign({
                        phaseId: this.currentPhase.id
                    },
                    this.queryParams)).then(response => {
                        const {total, otherData, rows, msg, code} = response
                            if (code == 200) {
                                this.constructionList = rows || [];
                                this.total = total
                            }
                    })
                }
            },


            // 打开/关闭修改项目备注对话框
            showPhaseRemarkForm(visible) {
                this.phaseRemarkFormVisiable = visible;
            },
            
            // 打开/关闭新增项目阶段对话框
            showPhaseForm(visible, phase) {
                this.phaseFormVisible = visible
                this.resetForm('phaseForm')
                this.phaseModel.id = null
                this.phaseFormTitle = 1
                if(phase) {
                    this.phaseModel.id = phase.id
                    this.phaseModel.phaseType = phase.phaseType
                    this.phaseModel.phaseNo = phase.phaseNo
                    this.phaseModel.responsor = phase.responsor
                    this.phaseModel.nodeTime = phase.nodeTime
                    this.phaseFormTitle = 2
                } else {
                    this.phaseModel.id = null
                    this.phaseModel.phaseType = null
                    this.phaseModel.phaseNo = null
                    this.phaseModel.responsor = null
                    this.phaseModel.nodeTime = null
                }
            },
            // 打开/关闭新增施工内容对话框
            showConstructionForm(visible, construction, editType) {
                this.constructionFormVisible = visible
                this.resetForm('constructionForm')
                this.constructionFormTitle = 1
                if(this.currentPhase) {
                    this.constructionModel.phaseId = this.currentPhase.id
                    this.constructionModel.phaseType = this.currentPhase.phaseType
                } else {
                    this.constructionModel.phaseId = null
                    this.constructionModel.phaseType = null
                }
                if(construction) {
                    this.constructionModel.id = construction.id
                    this.constructionModel.content = construction.content
                    this.constructionModel.planStart = construction.planStart
                    this.constructionModel.planEnd = construction.planEnd
                    this.constructionModel.actualStart = construction.actualStart
                    this.constructionModel.actualEnd = construction.actualEnd
                    this.constructionModel.remark = construction.remark
                    this.constructionFormTitle = 2
                } else {
                    this.constructionModel.id = null
                    this.constructionModel.content = null
                    this.constructionModel.planStart = null
                    this.constructionModel.planEnd = null
                    this.constructionModel.actualStart = null
                    this.constructionModel.actualEnd = null
                    this.constructionModel.remark = ''
                }
                this.editType = editType
            },


            // request修改项目交付备注
            reqUpdatePhaseRemark() {
                this.$refs["phaseRemarkForm"].validate(valid => {
                    if (valid) {
                        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
                        let newValue = this.phaseRemarkModel.phaseRemark
                        updatePhaseRemark(this.phaseRemarkModel).then(response => {
                            this.msgSuccess("操作成功");
                            this.resetForm('phaseRemarkForm')
                            this.showPhaseRemarkForm(false)
                            this.$emit('update:phaseRemark', newValue);
                        }).finally(() => {
                            loading.close()
                        })
                    }
                })
            },

            // 点击项目阶段卡片
            changeCurrentPhase(phase) {
                this.currentPhase = phase
                this.queryConstructionList()
            },
            showPhaseFollowDialog(phase) {
                this.phaseFollowListVisible = false
                this.phaseFollowPhase = phase
                this.phaseFollowVisible = true
            },
            handlePhaseFollowSuccess() {
                if (this.$refs.phaseFollowList) {
                    this.$refs.phaseFollowList.refresh()
                }
            },
            handlePhaseFollowListChange(payload) {
                this.phaseFollowListVisible = payload && payload.count > 0
            },

            // request保存项目阶段
            reqSavePhase() {
                this.$refs["phaseForm"].validate(valid => {
                    if (valid) {
                        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
                        saveContractPhase(this.phaseModel).then(response => {
                            this.msgSuccess("操作成功");
                            this.resetForm('phaseForm')
                            this.showPhaseForm(false, null)
                            this.queryPhaseList()
                        }).finally(() => {
                            loading.close()
                        })
                    }
                })
            },
            // request删除项目阶段
            reqDeletePhase(id) {
                this.$confirm('删除后将无法恢复，是否确认删除该阶段?', "警告", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中',
                        spinner: 'el-icon-loading'
                    });
                    deleteContractPhase(id).then(response => {
                        this.$message.success('阶段删除成功')
                        this.queryPhaseList();
                    }).finally(() => {
                        loading.close();
                    });
                })
            },
            // request保存施工内容
            reqSaveConstruction() {
                this.$refs["constructionForm"].validate(valid => {
                    if (valid) {
                        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
                        saveConstruction(this.constructionModel).then(response => {
                            this.msgSuccess("操作成功");
                            this.resetForm('constructionForm')
                            this.showConstructionForm(false, null, 0)
                            this.queryConstructionList()
                        }).finally(() => {
                            loading.close()
                        })
                    }
                })
            },
            // request删除施工内容
            reqDeleteConstruction(id) {
                console.log(id)
                this.$confirm('删除后将无法恢复，是否确认删除该施工内容?', "警告", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中',
                        spinner: 'el-icon-loading'
                    });
                    deleteConstruction(id).then(response => {
                        this.$message.success('施工内容删除成功')
                        this.queryConstructionList();
                    }).finally(() => {
                        loading.close();
                    });
                })
            },

            validatePlanEnd() {
                if(this.constructionModel.planEnd) {
                    this.$refs['constructionForm'].validateField('planEnd')
                }
            },
            validatePlanStart() {
                if(this.constructionModel.planStart) {
                    this.$refs['constructionForm'].validateField('planStart')
                }
            },
            validateActualEnd() {
                if(this.constructionModel.actualEnd) {
                    this.$refs['constructionForm'].validateField('actualEnd')
                }
            },
            validateActualStart() {
                if(this.constructionModel.actualStart) {
                    this.$refs['constructionForm'].validateField('actualStart')
                }
            }

        }
    }
</script>

<style lang="scss" scoped>
.main {
    padding-left: 10px;
}

.remark-container {
    background-color: #f2f2f2;

    .remark-title {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 5px;
    }

    .remark-content {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        word-break: break-all;
        font-size: 14px;
        padding: 5px;
    }
}


.container {
    display: flex;
    min-height: calc(100vh - 200px);
    margin-top: 10px;
}

.content {
    flex: 1;
    padding-left: 16px;
    overflow: hidden;
}


.phaseTitle {
    display: flex;
    justify-content:flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-bottom: 10px;

    .btn {
        width: 120px !important;
        height: 30px !important;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
    }
}

.phaseCard {
    height: 100px;
    border: 2px solid #dfe4ed;
    margin-top: 10px;
    padding: 5px;
    line-height: 30px;
    font-size: 14px;

    .phaseCardType {
        margin-left: 15px;
    }

    .phaseCardResponsor {
        margin-left: 15px;
    }

    .phaseCardThree {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .phaseCardNodeTime {
            margin-left: -10px;
        }

        .phaseCardActions {
            white-space: nowrap;
        }
    }
}

.phaseCard.active {
    border-color: #4480f3;
}

.phase-follow-dialog-list {
    height: 420px;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed #dcdfe6;
}

.progress {
    width: 100px;
    height:20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}
</style>
